import * as React from "react";
import './Loader.css';

export const Loader = () => <div className="loader"/>;


// WEBPACK FOOTER //
// ./src/components/genericComponents/Loader/Loader.tsx